import { auth } from '../lib/firebase/config';

export class FirebasePhoneAuthChecker {
  static async checkConfiguration(): Promise<{ isConfigured: boolean; errors: string[] }> {
    const errors: string[] = [];
    
    try {
      // Check if Firebase Auth is initialized
      if (!auth) {
        errors.push('Firebase Auth is not initialized');
        return { isConfigured: false, errors };
      }

      // Check if we have the required Firebase config
      const config = auth.app.options;
      if (!config.apiKey) {
        errors.push('Firebase API key is missing');
      }
      if (!config.authDomain) {
        errors.push('Firebase Auth domain is missing');
      }
      if (!config.projectId) {
        errors.push('Firebase Project ID is missing');
      }

      // Check if phone auth is enabled (this will be determined by trying to use it)
      console.log('Firebase configuration check:', {
        hasApiKey: !!config.apiKey,
        hasAuthDomain: !!config.authDomain,
        hasProjectId: !!config.projectId,
        authDomain: config.authDomain
      });

      if (errors.length === 0) {
        return { isConfigured: true, errors: [] };
      }

    } catch (error) {
      console.error('Firebase configuration check failed:', error);
      errors.push(`Configuration check failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }

    return { isConfigured: false, errors };
  }

  static getSetupInstructions(): string[] {
    return [
      '1. Go to Firebase Console: https://console.firebase.google.com',
      '2. Select your project',
      '3. Go to Authentication → Sign-in method',
      '4. Find "Phone" in the providers list',
      '5. Click on "Phone" and toggle "Enable"',
      '6. Click "Save"',
      '7. Go to Authentication → Settings → Authorized domains',
      '8. Make sure "localhost" is in the list for development',
      '9. If using a custom domain, add it to the authorized domains'
    ];
  }
}
